import { useQuery } from "@tanstack/react-query";
import { getMembersEnrollment } from "../../service/query/auth";

export const useGetMembersEnrollmentReport = ({ payload, page }) => {
  const membersEnrollement = useQuery({
    queryKey: ["membersEnrollmentReport", payload, page],
    queryFn: () => getMembersEnrollment({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  });
  return { data: membersEnrollement?.data?.data, ...membersEnrollement };
};
